import React from 'react';
import { connect } from 'react-redux';
import { setCurrentChannel, setPrivateChannel, setExplorePage } from '../../actions';
import { Menu } from 'semantic-ui-react';
import exploreIcon from '../Images/exploreIcon.png';

class Explore extends React.Component {
    state = {
        activeChannel: '',
        user: this.props.currentUser,
        channel: null,
        isExplorePage: false,
        isPrivateChannel: null,
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    changeChannel = (isExplorePage) => {
        this.setActiveChannel(isExplorePage);
        this.props.setCurrentChannel(false);
        this.props.setPrivateChannel(false);
        this.props.setExplorePage(true);
    };

    setActiveChannel = isExplorePage => {
        this.setState({ activeChannel: isExplorePage.id });
    };
    
    render() {
        const { isExplorePage } = this.state;
        return (
            <Menu.Menu className="channelMenuSections">
                <div className="channelTextExplore">
                <Menu.Item 
                    key={isExplorePage.id}
                    onClick={() => this.changeChannel(isExplorePage)}
                    active={isExplorePage.id === this.state.activeChannel}
                    className="channelMenuItem exploreSection"
                    style={{
                        color: '#fff', 
                        paddingBottom: '16px',
                    }}>
                    <span className="channelSpan" 
                        style={{ 
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        color: '#fff',
                        marginTop: '3px'
                        }}>
                        <img src={exploreIcon} alt="Icon" className="channelIcon" />&nbsp;&nbsp;EXPLORE
                    </span>
                </Menu.Item>
                </div>
            </Menu.Menu>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
    currentChannel: state.channel.currentChannel,
    isExplorePage: state.channel.isExplorePage
});

export default connect(mapStateToProps, { setCurrentChannel, setPrivateChannel, setExplorePage })(Explore);


// WEBPACK FOOTER //
// ./src/components/SidePanel/Explore.js